export default "__VITE_ASSET__CYZQB632__"